import axios from "../../utils/axios";

export const getNotices = async ({
  category,
  startDate,
  endDate,
  searchKeyword,
  pageNumber,
  pageSize,
  showOnLatest,
  showOnPopup,
  isArchived,
}) => {
  const res = await axios.get("notice/getList", {
    params: {
      category,
      startDate,
      endDate,
      searchKeyword,
      pageNumber,
      pageSize,
      showOnLatest,
      showOnPopup,
      isArchived,
    },
  });

  return res;
};

export const deleteNoticeById = async (id) => {
  const res = await axios.delete(`notice/${id}`);

  return res;
};

export const togglePublishedById = async (id) => {
  const res = await axios.patch(`notice/togglePublish/${id}`);

  return res;
};

export const toggleArchivedById = async (id) => {
  const res = await axios.patch(`notice/toggleArchived/${id}`);

  return res;
};

export const createNotice = async (formData) => {
  const res = await axios.post("notice/create", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res;
};

export const updateNoticeById = async (id, noticeData) => {
  const res = await axios.put(`notice/${id}`, noticeData);

  return res;
};
